import * as evilHardcodedSettings from '../mocks/settings/index.js';
export default {
  settings: {
    mimeType: 'application/ld+json',
    corsEnabled: false
  },
  environments: {
    staging: 'https://settings.staging-api.immediate.co.uk',
    preproduction: 'https://settings.preproduction-api.immediate.co.uk',
    production: 'https://settings.api.immediate.co.uk'
  },
  endpoints: {
    clients: {
      endpoint: '/v1/settings/clients',
      // TODO: Remove once real data is being pushed to the settings API
      mocks: originalFunctions => ({
        ...originalFunctions,
        get: async id => {
          var _mockSettings$siteCon, _data$siteConfig;
          const data = await originalFunctions.get(id);
          const mockSettings = evilHardcodedSettings[id];
          const mainNavigation = {
            ...(data === null || data === void 0 ? void 0 : data.mainNavigation)
          };

          // TODO: Remove this once work is complete to add wildcards via
          // WP admin
          if ((mockSettings === null || mockSettings === void 0 ? void 0 : mockSettings.site) === 'bbcgoodfood' || (mockSettings === null || mockSettings === void 0 ? void 0 : mockSettings.site) === 'historyextra') {
            mainNavigation.menuItems[mainNavigation.menuItems.length - 1].color = 2;
            mainNavigation.menuItems[mainNavigation.menuItems.length - 2].color = 1;
          }

          // Hello future developer. This horrible thing was all supposed to be
          // temporary. Sorry. Also, do you have hoverboards yet?
          return {
            ...data,
            ...mockSettings,
            mainNavigation,
            siteConfig: {
              ...(data === null || data === void 0 ? void 0 : data.siteConfig),
              search: {
                ...(mockSettings === null || mockSettings === void 0 ? void 0 : (_mockSettings$siteCon = mockSettings.siteConfig) === null || _mockSettings$siteCon === void 0 ? void 0 : _mockSettings$siteCon.search),
                ...(data === null || data === void 0 ? void 0 : (_data$siteConfig = data.siteConfig) === null || _data$siteConfig === void 0 ? void 0 : _data$siteConfig.search)
              }
            },
            // Find and replace in the web-bff etc., then remove this line.
            cards: data === null || data === void 0 ? void 0 : data.cardSettings,
            tracking: {
              ...(mockSettings === null || mockSettings === void 0 ? void 0 : mockSettings.tracking),
              ...(data === null || data === void 0 ? void 0 : data.tracking)
            },
            posts: {
              ...(mockSettings === null || mockSettings === void 0 ? void 0 : mockSettings.posts),
              ...(data === null || data === void 0 ? void 0 : data.posts)
            },
            header: {
              ...(mockSettings === null || mockSettings === void 0 ? void 0 : mockSettings.header),
              ...(data === null || data === void 0 ? void 0 : data.header)
            }
          };
        }
      })
    }
  }
};